import { Breadcrumb, Button, Col, Drawer, Flex, Form, Input, Layout, Popconfirm, Row, Select, Table, Tag, Tour, theme, notification, Checkbox } from 'antd';
import {
    FilterOutlined,
    HomeOutlined,
    DeleteOutlined,
    EyeOutlined,
    EditOutlined,
    UsergroupAddOutlined,
    AppstoreOutlined,
    CalendarOutlined,
    RightOutlined,
    LeftOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import data from './sampleData';
import Calendar from './Calender';
import { decodeToken } from "react-jwt";
import moment from 'moment';
import rellocationAPI from '../../../restAPI/SignatoryRellocationAPI';
import { useSelector } from 'react-redux';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';

const { Search } = Input;
const { Header, Footer, Sider, Content } = Layout;

export default function AltSignatoryRellocation({ props }) {
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const componentMounted = useRef(false);
    const [showUpdateButton, setShowUpdateButton] = useState(true);
    const [reallocationToken, setReallocationToken] = useState("");
    const [dateInt, setDateInt] = useState("");
    const [dateString, setDateString] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isReallocationTokenExpire, setIsReallocationTokenExpire] = useState(false);
    const navigate = useNavigate();
    const [allSignatoryMeetings, setAllSignatoryMeetings] = useState([]);
    const [tempAllSignatoryMeetings, setTempAllSignatoryMeetings] = useState([]);
    const [allLeaveApplierMeetings, setAllLeaveApplierMeetings] = useState([]);
    const [tempAllLeaveApplierMeetings, setTempAllLeaveApplierMeetings] = useState([]);
    const [isFetchAllMeetings, setIsFetchAllMeetings] = useState([true]);
    const [isUpdateEmailStatus, setIsUpdateEmailStatus] = useState([true]);
    const [decodedTokenValues, setDecodedTokenValues] = useState([]);
    const [selectedCount, setSelectedCount] = useState([]);
    const [isSaved, setIsSaved] = useState([false]);
    const [screenLoading, setScreenLoading] = useState(false)

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const [open, setOpen] = useState(true);
    const steps = [
        {
            title: 'Select',
            description: 'Select if you need to approve a meeting',
            target: () => ref1.current,
        },
        {
            title: 'Reallocation',
            description: 'Save the reallocations to complete the task',
            target: ref2.current,
        },
    ];
    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorPrimary,
            colorWarning,
            colorPrimaryBorder,
            colorTextDescription,
            colorText,
            colorBorder,
            fontSizeSM,
            colorErrorBgHover,
            colorPrimaryBgHover,


        },
    } = theme.useToken();

    useEffect(() => {
        if (window.location.href.includes("/Meeting-Management/alt-reallocation?token=")) {
            const parts = window.location.href.split("?token=");

            //set the token value to state
            setReallocationToken(parts[1]);

            //read the token values
            const decodedTokenValues = decodeToken(parts[1]);
            //console.log(JSON.stringify(decodedTokenValues));
            // set date values
            setDateValues(decodedTokenValues.type === "leave" ? decodedTokenValues.leaveAppliedDate : decodedTokenValues.meetingDate);

            //check reallocation token expiration
            setIsReallocationTokenExpire(checkTokenExpiration(decodedTokenValues));

            if (!isReallocationTokenExpire) {
                if (decodedTokenValues.type === 'leave') {
                    //call the update email status api
                    if (isUpdateEmailStatus) {
                        updateEmailStatusForLeaveType(decodedTokenValues);
                        setIsUpdateEmailStatus(false);

                        //set decoded token values
                        setDecodedTokenValues(decodedTokenValues);
                    }

                    //fetch all meetings for leave type
                    if (isFetchAllMeetings) {
                        fetchAllMeetingsForLeaveType(decodedTokenValues);
                        setIsFetchAllMeetings(false);
                    }
                } else if (decodedTokenValues.type === 'meeting') {
                    //console.log("meeting");

                    if (isUpdateEmailStatus) {
                        //updateEmailStatusForMeetingType(decodedTokenValues);
                        //setIsUpdateEmailStatus(false);

                        //set decoded token values
                        setDecodedTokenValues(decodedTokenValues);
                    }

                    //fetch all meetings for meeting type
                    if (isFetchAllMeetings) {
                        fetchAllMeetingsForMeetingType(decodedTokenValues);
                        setIsFetchAllMeetings(false);
                    }
                }
            }
            else {
                //alert("token expire");
                //token expire
                //openNotificationWithIcon('error', 'Your meeting link is timeout', 'Your meeting link is timeout', 'bottomLeft');
            }
        }
    }, []);

    const updateEmailStatusForLeaveType = async (decodedTokenValues) => {
        const updateEmailStatusObj = {
            signatoryId: decodedTokenValues.signatoryId,
            leaveDate: decodedTokenValues.leaveAppliedDate,
            leaveType: decodedTokenValues.appliedLeaveType,
            status: "viewed"
        };

        //console.log(JSON.stringify(updateEmailStatusObj));

        await rellocationAPI.updateEmailStatus(updateEmailStatusObj, companyId, token)
            .then((res) => {
                //openNotificationWithIcon('success', 'Successful', `Email status updated successfully`, 'bottomLeft');
            })
            .catch((err) => {
                if (err.response) {
                    //openNotificationWithIcon('error', 'Email status updated fail', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    //openNotificationWithIcon('error', 'Email status updated fail', `${err.message}`, 'bottomLeft');
                }
            });
    };

    const updateEmailStatusForMeetingType = async (decodedTokenValues) => {

    }

    const checkTokenExpiration = (decodedTokenValues) => {
        const date = new Date();
        const currTime = new Date(date).getTime();

        //different between issued at with expiration
        const timeDiffernceForExpireTime = decodedTokenValues.exp - decodedTokenValues.iat;

        //different between issued at with current
        const timeDiffernceForCurrentTime = Math.trunc(currTime / 1000) - decodedTokenValues.iat;

        if (timeDiffernceForExpireTime < timeDiffernceForCurrentTime) {
            return true;
        }
        else {
            return false;
        }
    };

    const setDateValues = (leaveAppliedDate) => {
        setDateInt(moment(leaveAppliedDate).format('DD'));
        setDateString(moment(leaveAppliedDate).format('dddd'));
        setMonth(moment(leaveAppliedDate).format('MMMM'));
        setYear(moment(leaveAppliedDate).year());
    };

    const fetchAllMeetingsForLeaveType = async (decodedTokenValues) => {
        const allMeetingsObj = {
            signatoryId: decodedTokenValues.signatoryId,
            leaveApplierId: decodedTokenValues.leaveApplierId,
            leaveDate: decodedTokenValues.leaveAppliedDate,
            leaveType: decodedTokenValues.appliedLeaveType
        };

        //console.log(JSON.stringify(allMeetingsObj));

        await rellocationAPI.fetchAllMeetingsForLeaveType(allMeetingsObj, companyId, token)
            .then((res) => {
                if (res?.data) {
                    //console.log(JSON.stringify(res.data));
                    ////signatory meetings
                    const signatoryMeetingsList = [];
                    res.data.signatoryMeetings.map((rowValue) => {
                        rowValue.meetings.map((meetingObj) => {
                            signatoryMeetingsList.push({
                                name: meetingObj.info.name, startTime: meetingObj.info.startDate, endTime: meetingObj.info.endDate,
                                meetingId: meetingObj._id, meetingDate: rowValue.meetingDate, meetingOriginalDate: meetingObj.originalDate, isSelected: false
                            });
                        });
                    });

                    //console.log("Signatory Meetings");
                    //console.log(JSON.stringify(signatoryMeetingsList));
                    setAllSignatoryMeetings(signatoryMeetingsList);
                    setTempAllSignatoryMeetings(signatoryMeetingsList);

                    // //leave applier meetings
                    const leaveApplierMeetingsList = [];
                    res.data.leaveApplierMeetings.map((rowValue) => {
                        rowValue.meetings.map((meetingObj) => {
                            leaveApplierMeetingsList.push({
                                name: meetingObj.info.name, startTime: meetingObj.info.startDate, endTime: meetingObj.info.endDate,
                                meetingId: meetingObj._id, meetingDate: rowValue.meetingDate, meetingOriginalDate: meetingObj.originalDate, isSelected: false
                            });
                        });
                    });

                    //console.log("Leave Applier Meetings");
                    //console.log(JSON.stringify(leaveApplierMeetingsList));
                    setAllLeaveApplierMeetings(leaveApplierMeetingsList);
                    setTempAllLeaveApplierMeetings(leaveApplierMeetingsList);
                }
            }).catch(err => {
                console.log("error getting meetings data :", err.message);
            })
    };

    const fetchAllMeetingsForMeetingType = async (decodedTokenValues) => {
        const decodedLoginTokenValue = decodeToken(token)
        const loggedInUserDetails = decodedLoginTokenValue.companyData.find(
            (company) => company.userDetailsId === decodedTokenValues.signatoryId
        )
        const meetingTypeObject = {
            signatoryId: decodedTokenValues.signatoryId,
            meetingOwnerId: decodedTokenValues.meetingOwnerId,
            meetingId: decodedTokenValues.meetingId,
            meetingOriginalDate: decodedTokenValues.meetingOriginalDate,
            meetingDate: decodedTokenValues.meetingDate
        };

        await rellocationAPI.fetchAllMeetingsForMeetingType(meetingTypeObject, decodedTokenValues.committeeCompanyId, token)
            .then((res) => {
                console.log("meetings response :", res)
                if (res?.data) {
                    //console.log(JSON.stringify(res.data));
                    ////signatory meetings
                    const signatoryMeetingsList = [];
                    res.data.signatoryMeetings.map((rowValue) => {
                        rowValue.meetings.map((meetingObj) => {
                            signatoryMeetingsList.push({
                                name: meetingObj.info.name, startTime: meetingObj.info.startDate, endTime: meetingObj.info.endDate,
                                meetingId: meetingObj._id, meetingDate: rowValue.meetingDate, meetingOriginalDate: meetingObj.originalDate, isSelected: false, committeeId: meetingObj.committeeId
                            });
                        });
                    });

                    //console.log(JSON.stringify(signatoryMeetingsList));
                    setAllSignatoryMeetings(signatoryMeetingsList);
                    setTempAllSignatoryMeetings(signatoryMeetingsList);

                    // //leave applier meetings
                    const leaveApplierMeetingsList = [];
                    res.data.leaveApplierMeetings.map((rowValue) => {
                        leaveApplierMeetingsList.push({
                            name: rowValue.info.name, startTime: rowValue.info.startDate, endTime: rowValue.info.endDate,
                            meetingId: rowValue._id, meetingDate: decodedTokenValues.meetingDate, meetingOriginalDate: decodedTokenValues.meetingOriginalDate, isSelected: false, committeeId: rowValue.committeeId
                        });
                    });

                    //console.log("Leave Applier Meetings");
                    //console.log(JSON.stringify(leaveApplierMeetingsList));
                    setAllLeaveApplierMeetings(leaveApplierMeetingsList);
                    setTempAllLeaveApplierMeetings(leaveApplierMeetingsList);
                }
            }).catch(err => {
                console.log("error getting meetings data :", err.message);
            })
    }

    const handleSaveChanges = async () => {

        //selected count
        const count = tempAllLeaveApplierMeetings.filter(meeting => meeting.isSelected === true);
        setSelectedCount(count.length);

        if (count.length == 0) {
            openNotificationWithIcon('error', 'Saving error', 'Select at least one meeting before saving', 'bottomLeft');
        }
        else {
            if (decodedTokenValues.type === 'leave') {
                const rows = [];
                tempAllLeaveApplierMeetings.map((rowValue) => {
                    if (rowValue.isSelected === true) {
                        rows.push({ meetingId: rowValue.meetingId, meetingDate: rowValue.meetingDate, meetingOriginalDate: rowValue.meetingOriginalDate });
                    }
                });

                const assignMeetingsObj = {
                    selectedMeetingIds: rows,
                    leaveDate: decodedTokenValues.leaveAppliedDate,
                    leaveType: decodedTokenValues.appliedLeaveType,
                    leaveApplierId: decodedTokenValues.leaveApplierId,
                    rsvp: { signatoryId: decodedTokenValues.signatoryId, type: decodedTokenValues.type }
                };

                //console.log(JSON.stringify(assignMeetingsObj));

                await rellocationAPI.assignMeetingsForLeaveType(assignMeetingsObj, companyId, token)
                    .then((response) => {
                        openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                        setIsSaved(true);
                    })
                    .catch((err) => {
                        if (err.response) {
                            openNotificationWithIcon('error', 'Rellocation creation failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            openNotificationWithIcon('error', 'Rellocation creation failed', `${err.message}`, 'bottomLeft');
                        }
                    });

            } else if (decodedTokenValues.type === 'meeting') {
                const rows = [];
                tempAllLeaveApplierMeetings.map((rowValue) => {
                    if (rowValue.isSelected === true) {
                        rows.push({
                            meetingId: rowValue.meetingId,
                            meetingName: rowValue.name,
                            meetingDate: rowValue.meetingDate,
                            meetingOriginalDate: rowValue.meetingOriginalDate,
                            meetingStartDateTime: rowValue.startTime,
                            meetingEndDateTime: rowValue.endTime,
                            committeeId: rowValue.committeeId
                        });
                    }
                });

                const assignMeetingsObj = {
                    selectedMeetingIds: rows,
                    leaveApplierId: decodedTokenValues.meetingOwnerId,
                    rsvp: { signatoryId: decodedTokenValues.signatoryId, type: decodedTokenValues.type }
                };

                //console.table(JSON.stringify(assignMeetingsObj));
                setScreenLoading(true)

                await rellocationAPI.assignMeetingsForMeetingType(assignMeetingsObj, companyId, token)
                    .then((response) => {
                        console.log('decodedTokenValues (after save) :', decodedTokenValues)
                        openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                        setIsSaved(true);
                        fetchAllMeetingsForMeetingType(decodedTokenValues);
                        setScreenLoading(false)
                    })
                    .catch((err) => {
                        setScreenLoading(false)
                        if (err.response) {
                            openNotificationWithIcon('error', 'Rellocation creation failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            openNotificationWithIcon('error', 'Rellocation creation failed', `${err.message}`, 'bottomLeft');
                        }
                    });
            }
        }
    }

    const styles = {
        calendar: {
            display: 'grid',
            gridTemplateColumns: '80px 1fr 1fr',
            height: '100vh',
            overFlowY: 'auto',
        },
        sidebar: {
            display: 'flex',
            flexDirection: 'column',
            padding: '0',
            margin: '0',
            borderRight: `1px solid ${colorBorder}`,
        },
        hour: {
            height: 'calc(100% / 24)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            fontSize: fontSizeSM,
            //   marginTop:'-4px'
            borderTop: `1px solid ${colorBorder}`,
        },
        hourText: {
            marginTop: '-10px',
            backgroundColor: colorBgContainer,
            paddingLeft: '4px',
            paddingRight: '4px'
        },
        meetingsContainer: {
            display: 'grid',
            gridTemplateRows: 'repeat(24, 1fr)',
            borderLeft: `1px solid ${colorBorder}`,
            position: 'relative',
        },
        gridHour: {
            position: 'relative',
            borderTop: `1px solid ${colorBorder}`,
            height: '50px'
        },
        meeting: {
            position: 'absolute',
            width: '90%',
            marginLeft: '5%',
            padding: '4px',
            borderRadius: '5px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            zIndex: '2'
            //   justifyContent: 'center',
        },
        myMeeting: {
            //   backgroundColor: colorErrorBgHover,
            backgroundColor: colorPrimaryBgHover,
            color: colorText,
        },
        otherMeeting: {
            backgroundColor: colorErrorBgHover,
            color: colorText,
        },
        meetingLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
        },
    };

    const handleCheckbox = (meetingId, e) => {
        const newOtherMeetings = tempAllLeaveApplierMeetings.map((rowValue) => {
            if (rowValue.meetingId == meetingId) {
                rowValue.isSelected = e.target.checked;
                return rowValue;
            }
            else {
                return rowValue;
            }
        });
        setSelectedCount(newOtherMeetings.filter(meeting => meeting.isSelected === true).length);
        setTempAllLeaveApplierMeetings(newOtherMeetings);
    }

    const calculateHeight = (startTime, endTime) => {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const startHours = start.getHours() + start.getMinutes() / 60;
        const endHours = end.getHours() + end.getMinutes() / 60;

        return (endHours - startHours) * 100; // Calculate height based on duration in percentage
    };

    const closeButtonClick = async () => {
        //call the backend api
        if (isSaved) {
            if (decodedTokenValues.type === 'leave') {

                const assignMeetingsObj = {
                    selectedMeetingIds: []
                };

                await rellocationAPI.assignMeetingsForLeaveType(assignMeetingsObj, companyId, token)
                    .then((response) => {
                        //openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                    })
                    .catch((err) => {
                        if (err.response) {
                            //openNotificationWithIcon('error', 'Rellocation creation failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            //openNotificationWithIcon('error', 'Rellocation creation failed', `${err.message}`, 'bottomLeft');
                        }
                    });
            } else if (decodedTokenValues.type === 'meeting') {
                const selectedRows = [];
                const unSelectedRows = [];
                tempAllLeaveApplierMeetings.map((rowValue) => {
                    if (rowValue.isSelected === true) {
                        selectedRows.push({
                            meetingId: rowValue.meetingId,
                            meetingName: rowValue.name,
                            meetingDate: rowValue.meetingDate,
                            meetingOriginalDate: rowValue.meetingOriginalDate,
                            meetingStartDateTime: rowValue.startTime,
                            meetingEndDateTime: rowValue.endTime,
                            committeeId: rowValue.committeeId
                        });
                    } else if (rowValue.isSelected === false) {
                        unSelectedRows.push({
                            meetingId: rowValue.meetingId,
                            meetingName: rowValue.name,
                            meetingDate: rowValue.meetingDate,
                            meetingOriginalDate: rowValue.meetingOriginalDate,
                            meetingStartDateTime: rowValue.startTime,
                            meetingEndDateTime: rowValue.endTime,
                            committeeId: rowValue.committeeId
                        });
                    }

                });

                const assignMeetingsObj = {
                    selectedMeetingIds: selectedRows,
                    unSelectedMeetingIds: unSelectedRows
                };

                //console.log(assignMeetingsObj);

                await rellocationAPI.assignMeetingsForMeetingType(assignMeetingsObj, companyId, token)
                    .then((response) => {
                        //openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                    })
                    .catch((err) => {
                        if (err.response) {
                            //openNotificationWithIcon('error', 'Rellocation creation failed', `${err.response.data.message}`, 'bottomLeft');
                        } else {
                            //openNotificationWithIcon('error', 'Rellocation creation failed', `${err.message}`, 'bottomLeft');
                        }
                    });
            }
        }

        //navigate to home page
        navigate("/home");
    }

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            // href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Alternative Signatory / Reallocation',
                        },
                    ]}
                />
                <div>
                    <Button type='primary' icon={<CloseOutlined />} onClick={closeButtonClick} style={{ position: 'absolute', top: 16, right: 20 }} />
                </div>

            </Flex>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Flex gap={16} align='center' justify='flex-start' style={{ fontSize: 24 }}>
                    <div
                        style={{ backgroundColor: colorPrimary, padding: '8px 12px', borderRadius: borderRadiusLG }}
                    >
                        {dateInt}
                    </div>
                    <div>{dateString}, {month} {year}</div>

                </Flex>
            </Flex>
            {screenLoading ? (<CommonSkeletonLoader itemCount={2} />) : (

                <div style={{
                    margin: '16px',
                    padding: 24,
                    height: "calc(66svh - 64px)",
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    overflowY: "auto"
                }}>
                    <div style={styles.calendar}>
                        {/* Sidebar with 24 hours */}
                        <div style={styles.sidebar}>
                            {Array.from({ length: 24 }, (_, i) => (
                                <div style={styles.hour} key={i}>
                                    <span style={styles.hourText}>{i}:00</span>
                                </div>
                            ))}
                        </div>

                        {/* My Meetings grid */}
                        <div style={styles.meetingsContainer}>
                            {Array.from({ length: 24 }, (_, i) => (
                                <div style={styles.gridHour} key={i}>
                                    {tempAllSignatoryMeetings.map((meeting, index) => {
                                        const start = new Date(meeting.startTime);
                                        const end = new Date(meeting.endTime);

                                        const meetingStartHour = start.getHours(); // Only the hour
                                        const meetingStartMinutes = start.getMinutes(); // Get minutes for top offset
                                        const meetingEndHour = end.getHours();
                                        const meetingEndMinutes = end.getMinutes();

                                        // Calculate the top offset and height based on start time and duration
                                        if (meetingStartHour === i) {
                                            const height = calculateHeight(meeting.startTime, meeting.endTime); // Calculate height
                                            const topOffset = (meetingStartMinutes / 60) * 100; // Calculate top offset in percentage

                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        ...styles.meeting,
                                                        ...styles.myMeeting,
                                                        height: `${height}%`,
                                                        top: `${topOffset}%`, // Set top offset to position the meeting within the hour
                                                    }}
                                                >
                                                    {meeting.name}
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}

                                </div>
                            ))}
                        </div>

                        {/* Other Meetings grid */}
                        <div style={styles.meetingsContainer}>
                            {Array.from({ length: 24 }, (_, i) => (
                                <div style={styles.gridHour} key={i}>
                                    {tempAllLeaveApplierMeetings.map((meeting, index) => {
                                        const start = new Date(meeting.startTime);
                                        const end = new Date(meeting.endTime);

                                        const meetingStartHour = start.getHours(); // Only the hour
                                        const meetingStartMinutes = start.getMinutes(); // Get minutes for top offset
                                        const meetingEndHour = end.getHours();
                                        const meetingEndMinutes = end.getMinutes();

                                        // Calculate the top offset and height based on start time and duration
                                        if (meetingStartHour === i) {
                                            const height = calculateHeight(meeting.startTime, meeting.endTime); // Calculate height
                                            const topOffset = (meetingStartMinutes / 60) * 100; // Calculate top offset in percentage

                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        ...styles.meeting,
                                                        ...styles.otherMeeting,
                                                        height: `${height}%`,
                                                        top: `${topOffset}%`, // Set top offset to position the meeting within the hour
                                                    }}
                                                >
                                                    <label style={styles.meetingLabel}>
                                                        <Checkbox onChange={(e) => handleCheckbox(meeting.meetingId, e)}>{meeting.name}</Checkbox>
                                                    </label>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {
                showUpdateButton && (
                    <Flex justify='space-between' align='center' gap={12} style={{
                        paddingLeft: 8,
                        paddingRight: 16,
                        backgroundColor: colorPrimary,
                        position: 'absolute',
                        bottom: 0,
                        width: 'calc(100% - 0px)'
                    }}>
                        <div><h3>You have Selected {selectedCount} </h3></div>
                        <Flex justify='space-around' align='center' gap={12}>

                            <Button type='default' onClick={handleSaveChanges} >Save</Button>
                            {/* <Button type='default' ref={ref3}>Next</Button> */}
                        </Flex>
                    </Flex>)
            }
            <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
            {contextHolder}
        </>
    )
}